import { useRouteMatch } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'

import useHasCmCampaignsQuery from '../../api/queries/useHasCmCampaignsQuery'
import { PATH } from '../interfaces'

import ContextualEmptyState from './ContextualEmptyState'
import { MetabaseDashboard } from './MetabaseDashboard'
import MetabaseNavPanel from './MetabaseNavPanel'

export const MetabaseAccountOverview = () => {
  const { enableMetabaseContextual } = useFlags()
  const isContextual = !!useRouteMatch(PATH.MetabaseAccountPersonalise)
  const isContextualEnabled = isContextual && !!enableMetabaseContextual

  const optimiseDashboardId =
    process.env.REACT_APP_METABASE_ACCOUNT_DASHBOARD_ID
  const contextualDashboardId =
    process.env.REACT_APP_METABASE_ACCOUNT_CONTEXTUAL_DASHBOARD_ID

  const { hasCmCampaigns, isLoading } =
    useHasCmCampaignsQuery(isContextualEnabled)

  const navPanel = (
    <MetabaseNavPanel
      optimisePath={PATH.MetabaseAccount}
      personalisePath={PATH.MetabaseAccountPersonalise}
    />
  )

  if (!optimiseDashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID is not defined')
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="rounded bg-coolGray-100 px-6 py-4 text-base-700">
          Unable to load the account overview dashboard. The dashboard
          configuration is missing.
        </div>
      </div>
    )
  }

  if (isContextualEnabled && !contextualDashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID not configured')
    return (
      <div className="flex h-full items-center justify-center p-10">
        <div className="rounded bg-coolGray-50 p-6 text-base-700">
          Unable to load account contextual overview. Please contact support.
        </div>
      </div>
    )
  }

  if (isContextualEnabled && isLoading) {
    return (
      <div className="relative overflow-y-auto overflow-x-hidden h-full flex w-full">
        {navPanel}
      </div>
    )
  }

  if (isContextualEnabled && !hasCmCampaigns) {
    return (
      <div className="relative overflow-y-auto overflow-x-hidden h-full flex w-full">
        {navPanel}
        <ContextualEmptyState />
      </div>
    )
  }

  const dashboardId = isContextual ? contextualDashboardId : optimiseDashboardId

  return <MetabaseDashboard dashboardId={dashboardId} leftNav={navPanel} />
}
